module.exports = __webpack_public_path__ + "media/customizations/wildblue/back-8be1226270fb56bdbf2764de3b988d24.jpg";